<div class="entity-card">
<div class="section-header">
  <span>Share capital</span>
</div>

<div class="section-body">
  <div class="ownership-row">
    <div>
      <span class="label">Form of ownership: </span>
      <span class="value">
        <span *ngIf="shareCapital?.usesStateCapital == true">State</span>
        <span *ngIf="shareCapital?.usesStateCapital == false">Private</span>
      </span>
    </div>
  </div>

  <nz-table *ngIf="shareCapital"
            class="share-table"
            [nzData]="shareCapital.shareClasses!"
            [nzShowPagination]="false">
    <thead>
    <tr>
      <th>Class Name</th>
      <th>Currency</th>
      <th>Number of votes per share</th>
      <th>Nominal value per share</th>
      <th>Total number of shares</th>
      <th>Ex. Rate</th>
      <th>Ex. Date</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of shareCapital?.shareClasses; let index = index">
      <td>
        <nz-avatar nzSrc="assets/icons/shares.svg" class="avatar"></nz-avatar>
        {{item.className}}
      </td>
      <td>{{item.currencyCode}}</td>
      <td>{{item.numberOfVotes}}</td>
      <td>{{item.nominalValue}}</td>
      <td>{{item.totalNumberOfShares}}</td>
      <td>{{getExchangeRate(item.currencyCode) ?? '-'}}</td>
      <td>{{getExchangeDate(item.currencyCode) ?? '-'}}</td>
    </tr>
    </tbody>
  </nz-table>

  <div class="capital-summary">
    <div>
      <span class="label">Total amount of share capital in KZT: </span>
      <span class="value">{{shareCapital?.totalAmountOfShareCapital | number:'1.0-2'}}</span>
    </div>
    <div class="divider"></div>
    <div nz-row>
      <div nz-col nzSpan="12">
        <span class="label">Amount of private capital in KZT: </span>
        <span class="value">{{shareCapital?.amountOfPrivateCapital | number:'1.0-2'}}</span>
      </div>
      <div nz-col nzSpan="12">
        <span class="label">Share of private capital: </span>
        <span class="value">{{shareCapital?.shareOfPrivateCapital | number:'1.0-2'}}%</span>
      </div>
    </div>
    <div nz-row>
      <div nz-col nzSpan="12">
        <span class="label">Amount of state capital in KZT: </span>
        <span class="value">{{shareCapital?.amountOfStateCapital | number:'1.0-2'}}</span>
      </div>
      <div nz-col nzSpan="12">
        <span class="label">Share of state capital: </span>
        <span class="value">{{shareCapital?.shareOfStateCapital | number:'1.0-2'}}%</span>
      </div>
    </div>
  </div>
</div>
</div>

<div class="entity-card">
<div class="section-header">
  <span>Shareholders</span>
</div>

<div class="shareholders-list">
  <div nz-row *ngFor="let item of shareCapital?.shareholders" class="shareholder-row">
    <div nz-col nzSpan="12">
      <div *ngIf="item.isIndividual" class="shareholder-info">
        <nz-avatar nzIcon="user" class="avatar"></nz-avatar>
        <div class="shareholder-text">
          <div class="name">{{item.firstName}} {{item.lastName}}</div>
          <div class="type">Individual</div>
        </div>
      </div>
      <div *ngIf="!item.isIndividual" class="shareholder-info">
        <nz-avatar nzSrc="assets/icons/corporate.svg" class="avatar"></nz-avatar>
        <div class="shareholder-text">
          <div class="name">{{item.companyName}}</div>
          <div class="type">Body Corporate</div>
        </div>
      </div>
    </div>
    <div nz-col nzSpan="12">
      <div class="shares-list">
        <div *ngFor="let share of item.shares" class="share-card">
          <div class="share-title">{{share.shareClassName}}</div>
          <div class="share-row">
            <span class="label">Number of shares contributed:</span>
            <span class="value">{{share.numberOfShares}}</span>
          </div>
          <div class="share-row">
            <span class="label">Shareholding:</span>
            <span class="value">{{share.percentage}}%</span>
          </div>
        </div>
        <div class="share-summary">
          <div class="share-row">
            <span class="label">Total shareholding:</span>
            <span class="value">{{item.totalShareholding | number:'1.0-2'}}</span>
          </div>
          <div class="share-row">
            <span class="label">Amount of share capital in KZT:</span>
            <span class="value">{{item.shareCapitalAmountKzt | number:'1.0-2'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
